import {
    Audiovisuals,
    DefaultMusicians,
    EnterMusicians,
    EnterMusicSong,
    ExitMusicians,
    ExitMusicSongs,
    GravesideMusicians,
    GravesideMusicSongs,
    Lifestory,
    OtherMusicians,
    OtherMusicSongs,
    ReflectionMusicians,
    ReflectionMusicSongs,
    RslMasonic
} from '../FuneralFragments';
import { buildTabDataFragment } from '../../../util/functions';
import gql from 'graphql-tag';

export default buildTabDataFragment(
    [
        gql`
            fragment PresentationFields on Funeral {
                NamesheetsRequired
                NamesheetsNotRequired
                NamesheetsDetails
                MassbookRequired
                MassbookDetails

                PersonalTouchesComment

                FlagRequired
                FlagType
                FlagDetails

                RslMasonicComment
                LastpostRequired
                ReveilleRequired
                PoppiesRequired

                DonationsCode
                DonationsName
                Donations2Code
                Donations2Name

                EnterMusicByWho
                EnterMusicByFamilyHandoverDate
                EnterMusicByFamilyHandoverTime
                EnterMusicByFamilyReceived
                EnterMusicNotes

                ReflectionMusicByWho
                ReflectionMusicByFamilyHandoverDate
                ReflectionMusicByFamilyHandoverTime
                ReflectionMusicByFamilyReceived
                ReflectionMusicNotes

                GravesideMusicByWho
                GravesideMusicByFamilyHandoverDate
                GravesideMusicByFamilyHandoverTime
                GravesideMusicByFamilyReceived
                GravesideMusicNotes

                ExitMusicByWho
                ExitMusicByFamilyHandoverDate
                ExitMusicByFamilyHandoverTime
                ExitMusicByFamilyReceived
                ExitMusicNotes

                OtherMusicByWho
                OtherMusicByFamilyHandoverDate
                OtherMusicByFamilyHandoverTime
                OtherMusicByFamilyReceived
                OtherMusicNotes
            }
        `,
        Audiovisuals,
        DefaultMusicians,
        EnterMusicians,
        EnterMusicSong,
        ExitMusicSongs,
        ExitMusicians,
        OtherMusicSongs,
        OtherMusicians,
        GravesideMusicians,
        GravesideMusicSongs,
        Lifestory,
        ReflectionMusicians,
        ReflectionMusicSongs,
        RslMasonic
    ],
    'Funeral'
);
